module.exports = __webpack_public_path__ + "img/item3.919a4b99.svg";